import { render, staticRenderFns } from "./GebruikerAanpassen.vue?vue&type=template&id=2d9c72f2&scoped=true"
import script from "./GebruikerAanpassen.vue?vue&type=script&lang=js"
export * from "./GebruikerAanpassen.vue?vue&type=script&lang=js"
import style0 from "./GebruikerAanpassen.vue?vue&type=style&index=0&id=2d9c72f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9c72f2",
  null
  
)

export default component.exports